<!--
 * @Author: Mr.Cong Wei
 * @Date: 2022-08-11 09:51:33
 * @LastEditTime: 2022-08-16 13:24:36
-->
<template>
  <div style="position: relative; margin-top: 8px; width: 30px; height: 23px;">
    <svg
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="23px"
      height="23px"
      style="position: absolute;"
    >
      <g transform="matrix(1 0 0 1 -256 -275 )">
        <path
          d="M 2.8482972136223452 0  C 1.2746130030959648 0.028482972136316675  0 1.3030959752322815  0 2.8767801857584345  L 0 20.151702786377655  C 0 21.725386996904035  1.2746130030959648 23  2.8482972136223452 23  L 20.123219814241565 23  C 21.69690402476772 23  22.971517027863683 21.725386996904035  23 20.151702786377655  L 23 2.8767801857584345  C 22.971517027863683 1.3030959752322815  21.69690402476772 0.028482972136316675  20.123219814241565 0  L 2.8482972136223452 0  Z "
          fill-rule="nonzero"
          fill="#bd9e55"
          stroke="none"
          transform="matrix(1 0 0 1 256 275 )"
        />
      </g>
    </svg>
    <svg
      xmlns:xlink="http://www.w3.org/1999/xlink"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="23px"
      height="23px"
      style="position: absolute;left: 7px;bottom: 7px;"
    >
      <g transform="matrix(1 0 0 1 -263 -268 )">
        <path
          d="M 2.8767801857584345 0  C 1.3030959752322815 0  0.028482972136316675 1.2746130030959648  0.028482972136316675 2.8482972136223452  L 0.028482972136316675 4.870588235294008  C 0.028482972136316675 5.027244582043295  0.15665634674928697 5.155417956656265  0.31331269349834656 5.155417956656265  L 14.426625386996877 5.155417956656265  C 16.306501547987637 5.155417956656265  17.844582043343735 6.693498452012363  17.844582043343735 8.573374613003125  L 17.844582043343735 22.686687306501653  C 17.844582043343735 22.843343653250713  17.972755417956705 22.971517027863683  18.129411764705992 22.971517027863683  L 20.151702786377655 22.971517027863683  C 21.725386996904035 22.971517027863683  23 21.69690402476772  23 20.123219814241565  L 23 2.8482972136223452  C 23 1.2746130030959648  21.725386996904035 0  20.151702786377655 0  L 2.8767801857584345 0  Z "
          fill-rule="nonzero"
          fill="#bd9e55"
          stroke="none"
          transform="matrix(1 0 0 1 263 268 )"
        />
      </g>
    </svg>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped></style>
